module.exports = __webpack_public_path__ + "img/m_banner.2073cb2c.png";